<template>
  <list-item
    class="index-list-item"
    :card="index"
    :custom-fields="index.dailyIndex ? [{
      label: 'Index Value',
      value: $filters.number(index.dailyIndex),
    }] : null"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <template #image>
      <index-image :index="index" />
    </template>

    <template #info>
      <align class="index-list-item-info" flex>
        <div class="label">{{ index.label }}</div>
      </align>
    </template>
  </list-item>
</template>

<script>
import Align from './Align';
import IndexImage from './IndexImage';
import ListItem from './ListItem';

export default {
  components: {
    Align,
    IndexImage,
    ListItem,
  },

  props: {
    index: Object,
  },
};
</script>

<style lang="scss" scoped>
@import '../scss/variables.scss';

.label {
  @include ellipsis;
  font-size: 22px;
  font-weight: bold;
}

.index-list-item-info {
  flex: 1;
}
</style>
